import { render, staticRenderFns } from "./TeamPosts.vue?vue&type=template&id=11f2bdc6&scoped=true&"
import script from "./TeamPosts.vue?vue&type=script&lang=js&"
export * from "./TeamPosts.vue?vue&type=script&lang=js&"
import style0 from "./TeamPosts.vue?vue&type=style&index=0&id=11f2bdc6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f2bdc6",
  null
  
)

export default component.exports